
export const sampleBenpos = [
  {
    folio: "NCD12345",
    name: "Rajesh Kumar",
    category: "Retail",
    units: 100,
    faceValue: 100000,
    bankAccount: "1234567890",
    ifscCode: "SBIN0001234",
    bankVerified: true
  },
  {
    folio: "NCD12346",
    name: "Priya Sharma",
    category: "Retail",
    units: 50,
    faceValue: 50000,
    bankAccount: "2345678901",
    ifscCode: "HDFC0002345",
    bankVerified: true
  },
  {
    folio: "NCD12347",
    name: "Axis Capital Limited",
    category: "Institutional",
    units: 1000,
    faceValue: 1000000,
    bankAccount: "3456789012",
    ifscCode: "UTIB0003456",
    bankVerified: false
  },
  {
    folio: "NCD12348",
    name: "Sunita Gupta",
    category: "Retail",
    units: 200,
    faceValue: 200000,
    bankAccount: "4567890123",
    ifscCode: "ICIC0004567",
    bankVerified: true
  },
  {
    folio: "NCD12349",
    name: "Akash Patel",
    category: "Non-Resident",
    units: 150,
    faceValue: 150000,
    bankAccount: "5678901234",
    ifscCode: "KKBK0005678",
    bankVerified: false
  },
  {
    folio: "NCD12350",
    name: "Global Investment Partners",
    category: "Institutional",
    units: 2000,
    faceValue: 2000000,
    bankAccount: "6789012345",
    ifscCode: "CITI0006789",
    bankVerified: true
  },
  {
    folio: "NCD12351",
    name: "Vikram Malhotra",
    category: "Retail",
    units: 75,
    faceValue: 75000,
    bankAccount: "7890123456",
    ifscCode: "PUNB0007890",
    bankVerified: false
  },
  {
    folio: "NCD12352",
    name: "Meera Singh",
    category: "Retail",
    units: 120,
    faceValue: 120000,
    bankAccount: "8901234567",
    ifscCode: "IDIB0008901",
    bankVerified: true
  },
  {
    folio: "NCD12353",
    name: "Tech Innovations Fund",
    category: "Institutional",
    units: 1500,
    faceValue: 1500000,
    bankAccount: "9012345678",
    ifscCode: "BARB0009012",
    bankVerified: false
  },
  {
    folio: "NCD12354",
    name: "Amit Shah",
    category: "Non-Resident",
    units: 180,
    faceValue: 180000,
    bankAccount: "0123456789",
    ifscCode: "YESB0001234",
    bankVerified: true
  }
];
